import Spinner from '@components/common/Spinner/index.js';
import React, { memo } from 'react';

import * as S from './button.styled.js';

// const ButtonSpinner = memo((props) => (
//   <S.ButtonSpinnerWrap {...props}>
//     {props.children}
//     {props.spinning && (
//       <S.SpinnerBox flexNone>
//         <Spinner fillColor={props.fillColor} size='small' />
//       </S.SpinnerBox>
//     )}
//   </S.ButtonSpinnerWrap>
// ));

const ButtonSpinner = memo(({ spinning, fillColor, children, isFeaturesDisableButton, ...rest }) => (
  <S.ButtonSpinnerWrap disabled={isFeaturesDisableButton} {...rest}>
    {children}
    {spinning && (
      <S.SpinnerBox flexNone>
        <Spinner fillColor={fillColor} size='small' />
      </S.SpinnerBox>
    )}
  </S.ButtonSpinnerWrap>
));

const ButtonLargeSpinner = memo((props) => (
  <S.ButtonLargeSpinnerWrap {...props}>
    {props.children}
    {props.spinning && (
      <S.SpinnerBox>
        <Spinner fillColor={props.saveSection || props.insideHeaderMenu ? '#fff' : '#3a3319'} size='small' />
      </S.SpinnerBox>
    )}
  </S.ButtonLargeSpinnerWrap>
));

const ButtonOutlinedSpinner = memo((props) => (
  <S.ButtonOutlinedSpinnerWrap {...props}>
    {props.children}
    {props.spinning && (
      <S.SpinnerBox>
        <Spinner size='small' />
      </S.SpinnerBox>
    )}
  </S.ButtonOutlinedSpinnerWrap>
));

export { ButtonLargeSpinner, ButtonOutlinedSpinner, ButtonSpinner };
